import {useTitle} from "../dashboard/TitleContext";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import * as React from "react";
import {useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import {useSnackbar} from "../../util/SnackbarProvider";
import {useNavigate} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid2 as Grid, Icon, InputLabel, Link, Menu, MenuItem, OutlinedInput, Select, TextField, Tooltip} from "@mui/material";
import {Add, ArrowDropUp, AttachFile, Autorenew, Bookmark, BookmarkBorder, ChatBubbleOutline, Check, Delete, Edit, FilterAltOff, Info, KeyboardArrowDown, MarkEmailRead, Markunread, PlayArrowOutlined, PriorityHigh, ReportOff} from "@mui/icons-material";
import {PRIORITIES, STATUSES} from "../../util/Const";
import ConfirmationDialog from "../common/ConfirmationDialog";
import TablePagination from "@mui/material/TablePagination";
import {limit} from "../../util/StringUtils";
import taskService from "../../services/TaskService";
import projectService from "../../services/ProjectService";
import userService from "../../services/UserService";
import IconButton from "@mui/material/IconButton";
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import authService from "../../services/AuthService";
import Typography from "@mui/material/Typography";
import FilterPanel from "../common/FilterPanel";
import projectTaskService from "../../services/ProjectTaskService";
import PercentageProgressBar from "../common/PercentageProgressBar";
import productProjectService from "../../services/ProductProjectService";

const ALL_COLUMNS = [
    {id: "noteText", label: "Jegyzet", fun: nt => <Tooltip title={nt}>{limit(nt, 50)}</Tooltip>},
    {id: "description", label: "Leírás", fun: d => <Tooltip title={d} placement="left">{limit(d, 50)}</Tooltip>},
    {
        id: "estimatedProgress", label: "Valós/Becsült Órák",
        fun: (p, task) => <Box
            sx={{'& div': {margin: '0px'}, '& div>div>input': {padding: "10px !important", fontSize: "14px"}}}>
            <PercentageProgressBar fullWidth percentage={p} narrow readonly usePercentage align='center'
                                   value={(p?.toFixed(1) || '0') + '%' + (task.estimatedHours != null ? (' (' + (task.realHours || '0') + '/' + task.estimatedHours + ')') : '')}/>
        </Box>
    },
    {
        id: "progressLevel", label: "Haladás",
        fun: p => <Box
            sx={{'& div': {margin: '0px'}, '& div>div>input': {padding: "10px !important", fontSize: "14px"}}}>
            <PercentageProgressBar fullWidth percentage={p} narrow readonly usePercentage align='center'/>
        </Box>
    },
    {id: "projectName", label: "Projekt", width: "200px"},
    {id: "projectTaskName", label: "Projekt Fejléc", width: "200px"},
    {id: "productProjectName", label: "Termék Projekt", width: "200px"},
    {id: "productProjectIterationSerialNumber", label: "Termék Projekt Gyártási Ciklus Azonosítója", width: "200px"},
    {id: "users", label: "Dolgozók"},
    {id: "candidates", label: "Jelöltek"},
    {
        id: "unseenChatMessageCount",
        label: <Tooltip title="Üzenetek" placement="top"><ChatBubbleOutline/></Tooltip>,
        width: "30px",
        align: "center",
        fun: (c) => c === 0 ? '' : <div>{c}</div>
    },
    {
        id: "fileCount",
        label: <Tooltip title="Fájlok" placement="top"><AttachFile/></Tooltip>,
        width: "30px",
        align: "center",
        fun: c => c === 0 ? '' : c
    },
    {id: "scheduleDateStart", label: "Ütemezés kezdete", width: "150px"},
    {id: "scheduleDateEnd", label: "Ütemezés vége", width: "150px"},
    {id: "deadline", label: "Határidő", width: "150px"},
    {id: "createdAt", label: "Létrehozva", width: "150px"},
    {id: "updatedAt", label: "Módosítva", width: "150px"},
    {id: "lastModifiedBy", label: "Módosította", width: "150px"},
]

const DEFAULT_COLUMNS = ['description', 'projectName', 'users', 'candidates', 'unseenChatMessageCount', 'fileCount', 'updatedAt'];

const USER_TASK_STATS_COLUMNS = [
    {id: "username", label: "Név", align: "right", width: "150px"},
    {id: "taskCount", label: "Feladatok Száma", align: "center"},
    {id: "totalHours", label: "Becsült Időtartam (Óra)", align: "center"},
]

const LOCAL_STORAGE_ITEM_NAME = "tasks-rows-per-page"
const LOCAL_STORAGE_SEARCH_PARAMS = "tasks-search-params"
const LOCAL_STORAGE_COLUMN_NAMES = "task-column-names"
const DEFAULT_SEARCH_PARAMS = {}

export default function Tasks() {

    useTitle([{name: 'Feladatok'}])

    const {sendAlertMessage} = useSnackbar()
    const navigate = useNavigate();
    const [dialogState, setDialogState] = React.useState({open: false, object: null})
    const [tableData, setTableData] = useState({
        page: 0,
        rowsPerPage: localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) || 25,
        totalCount: 0
    })
    const [searchParams, setSearchParams] = useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SEARCH_PARAMS)) || DEFAULT_SEARCH_PARAMS)
    const [columnNames, setColumnNames] = React.useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_COLUMN_NAMES)) || DEFAULT_COLUMNS)
    const [expanded, setExpanded] = useState(true);
    const [expandedUserTaskStats, setExpandedUserTaskStats] = useState(false);
    const handleDeletionClick = (object) => setDialogState({open: true, object: object})
    const handleClose = () => setDialogState({open: false, object: null})
    const currentUser = authService.getCurrentUser()
    const filterPanelRef = React.useRef();
    const canSeeUserStats = ['ROLE_CEO', 'ROLE_ADMIN'].includes(authService.getCurrentUser().role)

    useEffect(() => {
        retrieveTasks()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.page, tableData.rowsPerPage, searchParams])

    const [projects, setProjects] = useState([]);
    useEffect(() => {
        projectService.getSelectors()
            .then(response => setProjects([{id: -1, name: "Projekt Nélkül"}, ...response]))
            .catch(error => console.error(error))
    }, []);

    const [users, setUsers] = useState([]);
    useEffect(() => {
        userService.getSelectors()
            .then(response => setUsers([{id: -1, name: "Dolgozó Nélkül"}, ...response]))
            .catch(error => console.error(error))
    }, []);

    const [productProjects, setProductProjects] = useState([]);
    useEffect(() => {
        productProjectService.getSelectors()
            .then(response => setProductProjects(response))
            .catch(error => console.error(error))
    }, []);

    const [productProjectIterations, setProductProjectIterations] = useState([]);
    useEffect(() => {
        if (!searchParams?.productProject?.id) return
        productProjectService.findById(searchParams.productProject.id)
            .then(response => setProductProjectIterations(response.iterations))
            .catch(error => console.error(error))
    }, [searchParams?.productProject]);

    const [userTaskStats, setUserTaskStats] = React.useState([]);
    useEffect(() => {
        if (!canSeeUserStats) return
        taskService.getUserTaskStats()
            .then(response => setUserTaskStats(response.content))
            .catch(error => console.error(error))
    }, []);

    const retrieveTasks = () => {
        taskService.search(buildQueryParams())
            .then(response => setTableData((prev) => ({
                ...prev,
                totalCount: response.totalElements,
                rows: response.content
            })))
            .catch(error => sendAlertMessage(error?.message || "Feladatok lekérése sikertelen", 'error'))
    }

    function buildQueryParams() {
        return {
            page: tableData.page,
            size: tableData.rowsPerPage,
            ...(searchParams?.orderBy && {orderBy: searchParams.orderBy}),
            ...(searchParams?.sort && {sort: searchParams.sort}),
            ...(searchParams?.onlyUnseen && {onlyUnseen: searchParams.onlyUnseen}),
            ...(searchParams?.onlyMarked && {onlyMarked: searchParams.onlyMarked}),
            ...(searchParams?.description && {description: searchParams.description}),
            ...(searchParams?.noteText && {noteText: searchParams.noteText}),
            ...(searchParams?.statuses && {statuses: searchParams.statuses}),
            ...(searchParams?.priorities && {priorities: searchParams.priorities}),
            ...(searchParams?.fromDate && {fromDate: searchParams.fromDate + "T00:00:00"}),
            ...(searchParams?.toDate && {toDate: searchParams.toDate + "T00:00:00"}),
            ...(searchParams?.project && (searchParams.project.id === -1 ? {withoutProjectTask: true} : {projectId: searchParams.project.id})),
            ...(searchParams?.projectTask && {projectTaskId: searchParams.projectTask.id}),
            ...(searchParams?.productProject && {productProjectId: searchParams.productProject.id}),
            ...(searchParams?.productProjectIteration && {productProjectIterationId: searchParams.productProjectIteration.id}),
            ...(searchParams.users && {userIds: searchParams.users.map(user => user.id).filter(id => id !== -1)}),
            ...(searchParams.users && (searchParams.users.map(user => user.id).includes(-1) ? {withoutUser: true} : {})),
            ...(searchParams.candidates && {candidateIds: searchParams.candidates.map(user => user.id)}),
        }
    }

    const deleteTask = (id) => {
        taskService.delete(id)
            .then(() => {
                sendAlertMessage('Feladat sikeresen törölve')
                retrieveTasks()
            })
            .catch(error => sendAlertMessage(error?.message || 'Feladat törlése sikertelen', 'error'))
    }

    const onMultipleSelectChange = (event) => {
        const {value, name} = event.target
        const newSelection = typeof value === 'string' ? value.split(',') : value;
        const uniqueSelection = newSelection.reduce((acc, object) => {
            const exists = acc.find(item => item === object);
            if (exists) return acc.filter(item => item !== object);
            else return [...acc, object];
        }, []);

        setSearchParams((prev) => ({
            ...prev,
            [name]: uniqueSelection,
        }));
    };

    const onMultipleSelectChangeWithId = (event) => {
        const {value, name} = event.target
        const newSelection = typeof value === 'string' ? value.split(',') : value;
        const uniqueSelection = newSelection.reduce((acc, object) => {
            const exists = acc.find(item => item.id === object.id);
            if (exists) return acc.filter(item => item.id !== object.id);
            else return [...acc, object];
        }, []);

        setSearchParams((prev) => ({
            ...prev,
            [name]: uniqueSelection,
        }));
    };

    const onSearchParamsChange = (event, n, v) => {
        let name = event?.target?.name || n
        let value = event?.target?.value || v
        setSearchParams((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const clear = () => {
        if (searchParams != null) sendAlertMessage('Szűrők alaphelyzetbe állítva', 'info')
        setSearchParams(DEFAULT_SEARCH_PARAMS)
        filterPanelRef.current?.resetSelection();
    }

    useEffect(() => {
        if (searchParams) localStorage.setItem(LOCAL_STORAGE_SEARCH_PARAMS, JSON.stringify(searchParams));
        else localStorage.removeItem(LOCAL_STORAGE_SEARCH_PARAMS)
    }, [searchParams]);

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250
            },
        },
    };

    function getStyles(object, array) {
        if (array == null) return
        if (array.includes(object) || (object.id != null && array.map(o => o.id).includes(object.id))) {
            return {
                backgroundColor: "#2e7d32",
                color: "white"
            }
        } else return {}
    }

    const [context, setContext] = useState()
    const [contextMenu, setContextMenu] = useState(null)
    const handleCloseContextMenu = () => setContextMenu(null)
    const handleContextMenu = (event, task) => {
        event.stopPropagation()
        event.preventDefault()
        setContext({task: task})
        setContextMenu(contextMenu === null ? {mouseX: event.clientX + 2, mouseY: event.clientY - 6} : null);
    };

    const [openSetPriorityDialog, setOpenSetPriorityDialog] = useState(false);
    const handleOpenSetPriorityDialogClose = () => {
        setOpenSetPriorityDialog(false);
    }

    const onChangeColumnCheckBox = (event) => {
        const {checked, name} = event.target;
        setColumnNames((prev) => {
            return checked ? prev.includes(name) ? prev : [...prev, name] : prev.filter((col) => col !== name);
        });
    };

    useEffect(() => {
        if (columnNames) localStorage.setItem(LOCAL_STORAGE_COLUMN_NAMES, JSON.stringify(columnNames));
        else localStorage.removeItem(LOCAL_STORAGE_COLUMN_NAMES)
    }, [columnNames]);

    const [projectTasks, setProjectTasks] = useState();
    useEffect(() => {
        if (!searchParams?.project?.id) {
            setProjectTasks([])
            setSearchParams((prev) => ({...prev, projectTask: null}))
            return
        }
        projectTaskService.search(searchParams.project.id, {size: 100})
            .then(response => setProjectTasks(response.content))
            .catch(error => console.log(error));
    }, [searchParams?.project]);

    const onChangeCheckBox = (event) => {
        const {name, checked} = event.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const [openTaskDetails, setOpenTaskDetails] = useState(false);
    const [taskDetailsContent, setTaskDetailsContent] = useState();
    const handleClickOpenTaskDetails = (task) => {
        setOpenTaskDetails(task);
        setTaskDetailsContent(task)
    }

    const handleCloseTaskDetails = () => {
        setOpenTaskDetails(false);
    };

    const tableStyle = {
        tableLayout: 'fixed',
        width: '250px',
        borderSpacing: '0px',
        '& td': {padding: '8px', border: 'none'},
        '& td:nth-child(1)': {fontWeight: 'bold'},
    }

    const setSeen = (id, seen, e) => {
        if (e) e.stopPropagation()
        taskService.setSeen(id, seen)
            .then(() => retrieveTasks())
            .catch(() => 'Feladat frissítése sikertelen!', 'error')
    }

    const setMarked = (id, seen, e) => {
        if (e) e.stopPropagation()
        taskService.setMarked(id, seen)
            .then(() => retrieveTasks())
            .catch(() => 'Feladat frissítése sikertelen!', 'error')
    }

    return (
        <>
            {canSeeUserStats &&
                <Accordion style={{marginBottom: "10px"}} disableGutters expanded={expandedUserTaskStats}
                           onChange={() => setExpandedUserTaskStats(!expandedUserTaskStats)}>
                    <AccordionSummary
                        expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{
                        minHeight: "0px",
                        fontSize: "24px",
                        fontWeight: "bold",
                        backgroundColor: "darkgray",
                        borderRadius: "4px 4px 0px 0px",
                        paddingLeft: "20px",
                        margin: "0"
                    }}>
                        Dolgozói Terheltség
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {USER_TASK_STATS_COLUMNS.map((column, index) => (
                                            <TableCell key={index} sx={{
                                                fontWeight: "bold",
                                                textAlign: column.align
                                            }}>{column.label}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {userTaskStats.map((row, index) => (
                                        <TableRow key={index}>
                                            {USER_TASK_STATS_COLUMNS.map((column, i) => (
                                                <TableCell key={i} sx={{
                                                    padding: "0px",
                                                    textAlign: column.align,
                                                    width: column.width
                                                }}>{row[column.id]}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>}

            <Accordion style={{marginBottom: "10px"}} disableGutters expanded={expanded}
                       onChange={() => setExpanded(!expanded)}>
                <AccordionSummary
                    expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{
                    minHeight: "0px",
                    fontSize: "24px",
                    fontWeight: "bold",
                    backgroundColor: "darkgray",
                    borderRadius: "4px 4px 0px 0px",
                    paddingLeft: "20px",
                    margin: "0"
                }}>
                    Keresési Feltételek
                </AccordionSummary>
                <AccordionDetails className="filter-panel">
                    <Grid container columns={10} spacing={2} padding={"10px"}>
                        <Grid size={{xs: 7}}>
                            <Grid container columns={20} spacing={2} padding={"10px"}>
                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <FormControl sx={{m: 1, minWidth: 120, marginTop: "0px", marginLeft: "0px"}}
                                                 fullWidth>
                                        <InputLabel id="priorities-label">Prioritás</InputLabel>
                                        <Select
                                            labelId="priorities-label"
                                            multiple
                                            value={searchParams.priorities || []}
                                            onChange={onMultipleSelectChange}
                                            name="priorities"
                                            variant="outlined"
                                            input={<OutlinedInput id="select-multiple-chip" label="Prioritás"/>}
                                            renderValue={(selected) => (
                                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1.0, margin: "-5px"}}>
                                                    {selected.map((value, index) => (
                                                        <Chip key={index} label={PRIORITIES[value]}/>
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {Object.entries(PRIORITIES).map(([key, value]) => (
                                                <MenuItem key={key} value={key}
                                                          style={getStyles(key, searchParams.priorities)}>
                                                    {value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <FormControl sx={{m: 1, minWidth: 120, marginTop: "0px", marginLeft: "0px"}}
                                                 fullWidth>
                                        <InputLabel id="statuses-label">Státusz</InputLabel>
                                        <Select
                                            labelId="statuses-label"
                                            multiple
                                            value={searchParams.statuses || []}
                                            onChange={onMultipleSelectChange}
                                            name="statuses"
                                            variant="outlined"
                                            input={<OutlinedInput id="select-multiple-chip" label="Státusz"/>}
                                            renderValue={(selected) => (
                                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1.0, margin: "-5px"}}>
                                                    {selected.map((value, index) => (
                                                        <Chip key={index} label={STATUSES[value]}/>
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {Object.entries(STATUSES).map(([key, value]) => (
                                                <MenuItem key={key} value={key}
                                                          style={getStyles(key, searchParams.statuses)}>
                                                    {value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        type="date"
                                        slotProps={{inputLabel: {shrink: true}}}
                                        label="-tól"
                                        name="fromDate"
                                        autoComplete="off"
                                        onChange={onSearchParamsChange}
                                        sx={{marginTop: "0px"}}
                                        value={(searchParams && searchParams.fromDate) || "-1"}
                                    />
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        type="date"
                                        slotProps={{inputLabel: {shrink: true}}}
                                        label="-ig"
                                        name="toDate"
                                        autoComplete="off"
                                        onChange={onSearchParamsChange}
                                        sx={{marginTop: "0px"}}
                                        value={(searchParams && searchParams.toDate) || "-1"}
                                    />
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}} style={{textAlign: "left"}}>
                                    <FormControlLabel control={<Checkbox
                                        variant="outlined"
                                        margin="normal"
                                        size="large"
                                        label="Csak Olvasatlanok"
                                        name="onlyUnseen"
                                        onChange={onChangeCheckBox}
                                        checked={searchParams?.onlyUnseen || false}
                                        value={searchParams?.onlyUnseen || false}
                                    />} label="Csak Olvasatlanok" style={{paddingTop: "0px"}}/>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}} style={{textAlign: "left"}}>
                                    <FormControlLabel control={<Checkbox
                                        variant="outlined"
                                        margin="normal"
                                        size="large"
                                        label="Csak Megjelöltek"
                                        name="onlyMarked"
                                        onChange={onChangeCheckBox}
                                        checked={searchParams?.onlyMarked || false}
                                        value={searchParams?.onlyMarked || false}
                                    />} label="Csak Megjelöltek" style={{paddingTop: "0px"}}/>
                                </Grid>

                                <Grid size={{xs: 20}}><Divider/></Grid>

                                <Grid size={{xs: 20}}>
                                    {ALL_COLUMNS.map((item, index) => (
                                        <FormControlLabel key={index}
                                                          control={<Checkbox
                                                              variant="outlined"
                                                              margin="normal"
                                                              size="large"
                                                              name={item.id}
                                                              onChange={onChangeColumnCheckBox}
                                                              checked={columnNames?.includes(item.id) || false}
                                                              sx={{padding: "0px"}}
                                                          />} label={item.label?.props?.title || item.label}
                                                          style={{paddingRight: "20px", margin: "0px"}}/>
                                    ))}
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <FilterPanel
                                type="TASK"
                                ref={filterPanelRef}
                                currentSearchParams={searchParams}
                                onFilterSelect={(params) => setSearchParams(params)}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <Paper sx={{width: '100%', overflow: 'hidden', fontSize: '10px'}}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table" sx={{tableLayout: "fixed"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell key="actions"
                                           style={{width: "180px", paddingLeft: "10px"}}
                                           align='left' padding='none'>
                                    <Tooltip title="Új hozzáadása">
                                        <Button variant='contained' color='success'
                                                sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                                onClick={() => navigate("/dashboard/tasks/create")}>
                                            <Add fontSize="large"/>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Szűrők törlése">
                                        <Button variant='contained' color='info'
                                                sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                                onClick={clear}>
                                            <FilterAltOff fontSize="large"/>
                                        </Button>
                                    </Tooltip>
                                    <IconButton onClick={() => setSearchParams(prev => ({
                                        ...prev,
                                        orderBy: 'ownPriority',
                                        sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                    }))}>
                                        {searchParams.sort == null || searchParams.orderBy !== 'ownPriority' ?
                                            <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                            searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                    </IconButton>
                                </TableCell>
                                {columnNames.includes('noteText') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <TextField name="noteText" label="Jegyzet" size="small"
                                                   value={searchParams.noteText || ""} onChange={onSearchParamsChange}
                                                   sx={{margin: "0px", width: "calc(100% - 40px)"}} autoComplete="off"/>
                                    </TableCell>}
                                {columnNames.includes('description') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <TextField name="description" label="Leírás" size="small"
                                                   value={searchParams.description || ""}
                                                   onChange={onSearchParamsChange}
                                                   sx={{margin: "0px", width: "calc(100% - 40px)"}} autoComplete="off"/>
                                        <IconButton onClick={() => setSearchParams(prev => ({
                                            ...prev,
                                            orderBy: 'description',
                                            sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                        }))}>
                                            {searchParams.sort == null || searchParams.orderBy !== 'description' ?
                                                <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                        </IconButton>
                                    </TableCell>}
                                {columnNames.includes('estimatedProgress') &&
                                    <TableCell sx={{padding: "0px", width: "auto"}}>Valós/Becsült Idő
                                    </TableCell>}
                                {columnNames.includes('progressLevel') &&
                                    <TableCell sx={{padding: "0px", width: "auto"}}>Haladás
                                    </TableCell>}
                                {columnNames.includes('projectName') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <Box sx={{display: "flex", alignItems: "center"}}>
                                            <Autocomplete
                                                value={searchParams?.project || null}
                                                name="project"
                                                size="small"
                                                onChange={(e, v) => onSearchParamsChange(e, "project", v)}
                                                options={projects}
                                                getOptionLabel={(project) => project.name}
                                                sx={{margin: "0px", width: "calc(100% - 40px)"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Projekt"/>
                                                )}
                                            />
                                            <IconButton onClick={() => setSearchParams(prev => ({
                                                ...prev,
                                                orderBy: 'projectName',
                                                sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                            }))}>
                                                {searchParams.sort == null || searchParams.orderBy !== 'projectName' ?
                                                    <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                    searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                            </IconButton>
                                        </Box>
                                    </TableCell>}
                                {columnNames.includes('projectTaskName') &&
                                    <TableCell sx={{padding: "0px", width: "auto"}}>
                                        <Box sx={{display: "flex", alignItems: "center"}}>
                                            <Autocomplete
                                                value={searchParams?.projectTask || null}
                                                name="projectTask"
                                                size="small"
                                                onChange={(e, v) => onSearchParamsChange(e, "projectTask", v)}
                                                options={projectTasks || []}
                                                getOptionLabel={(projectTask) => projectTask.description}
                                                sx={{margin: "0px", width: "calc(100% - 40px)"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Projekt Fejléc"/>
                                                )}
                                            />
                                            <IconButton onClick={() => setSearchParams(prev => ({
                                                ...prev,
                                                orderBy: 'projectTaskName',
                                                sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                            }))}>
                                                {searchParams.sort == null || searchParams.orderBy !== 'projectTaskName' ?
                                                    <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                    searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                            </IconButton>
                                        </Box>
                                    </TableCell>}
                                {columnNames.includes('productProjectName') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <Box sx={{display: "flex", alignItems: "center"}}>
                                            <Autocomplete
                                                value={searchParams?.productProject || null}
                                                name="productProject"
                                                size="small"
                                                onChange={(e, v) => onSearchParamsChange(e, "productProject", v)}
                                                options={productProjects}
                                                getOptionLabel={(productProject) => productProject.name}
                                                sx={{margin: "0px", width: "calc(100% - 40px)"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Termék Projekt"/>
                                                )}
                                            />
                                            <IconButton onClick={() => setSearchParams(prev => ({
                                                ...prev,
                                                orderBy: 'productProjectName',
                                                sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                            }))}>
                                                {searchParams.sort == null || searchParams.orderBy !== 'productProjectName' ?
                                                    <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                    searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                            </IconButton>
                                        </Box>
                                    </TableCell>}
                                {columnNames.includes('productProjectIterationSerialNumber') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <Box sx={{display: "flex", alignItems: "center"}}>
                                            <Autocomplete
                                                value={searchParams?.productProjectIteration || null}
                                                name="productProjectIteration"
                                                size="small"
                                                onChange={(e, v) => onSearchParamsChange(e, "productProjectIteration", v)}
                                                options={productProjectIterations}
                                                getOptionLabel={(iteration) => iteration.serialNumber}
                                                sx={{margin: "0px", width: "calc(100% - 40px)"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Termék Projekt Gyártási Ciklus"/>
                                                )}
                                            />
                                            <IconButton onClick={() => setSearchParams(prev => ({
                                                ...prev,
                                                orderBy: 'productProjectIteration',
                                                sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                            }))}>
                                                {searchParams.sort == null || searchParams.orderBy !== 'productProjectIteration' ?
                                                    <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                    searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                            </IconButton>
                                        </Box>
                                    </TableCell>}
                                {columnNames.includes('users') && <TableCell sx={{padding: "8px"}}>
                                    <FormControl sx={{m: 1, minWidth: 120, margin: "0px"}} fullWidth size="small">
                                        <InputLabel id="users-label">Dolgozók</InputLabel>
                                        <Select
                                            labelId="users-label"
                                            multiple
                                            value={searchParams.users || []}
                                            onChange={onMultipleSelectChangeWithId}
                                            label="Dolgozók"
                                            name="users"
                                            variant="outlined"
                                            input={<OutlinedInput id="select-multiple-chip" label="Dolgozók"/>}
                                            renderValue={(selected) => (
                                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1.0, margin: "-5px"}}>
                                                    {selected.map((value, index) => (
                                                        <Chip key={index} label={value.name}/>
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {users.map((user, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={user}
                                                    style={getStyles(user, searchParams.users)}
                                                >
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </TableCell>}
                                {columnNames.includes('candidates') && <TableCell sx={{padding: "8px"}}>
                                    <FormControl sx={{m: 1, minWidth: 120, margin: "0px"}} fullWidth size="small">
                                        <InputLabel id="candidates-label" sx={{margin: "0px"}}>Jelöltek</InputLabel>
                                        <Select
                                            labelId="candidates-label"
                                            multiple
                                            value={searchParams.candidates || []}
                                            onChange={onMultipleSelectChangeWithId}
                                            label="Jelöltek"
                                            name="candidates"
                                            variant="outlined"
                                            input={<OutlinedInput id="select-multiple-chip" label="Jelöltek"/>}
                                            renderValue={(selected) => (
                                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1.0, margin: "-5px"}}>
                                                    {selected.map((value, index) => (
                                                        <Chip key={index} label={value.name}/>
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {users.map((user, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={user}
                                                    style={getStyles(user, searchParams.candidates)}
                                                >
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </TableCell>}
                                {columnNames.includes('unseenChatMessageCount') &&
                                    <TableCell sx={{width: "30px", textAlign: "center", padding: "0px"}}><Tooltip
                                        title="Üzenetek" placement="top"><ChatBubbleOutline/></Tooltip>
                                    </TableCell>}
                                {columnNames.includes('fileCount') &&
                                    <TableCell sx={{width: "30px", textAlign: "center", padding: "0px"}}><Tooltip
                                        title="Fájlok" placement="top"><AttachFile/></Tooltip>
                                    </TableCell>}
                                {columnNames.includes('scheduleDateStart') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Ütemezés kezdete</TableCell>
                                }
                                {columnNames.includes('scheduleDateEnd') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Ütemezés vége</TableCell>
                                }
                                {columnNames.includes('deadline') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Határidő</TableCell>
                                }
                                {columnNames.includes('createdAt') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Létrehozva
                                        <IconButton onClick={() => setSearchParams(prev => ({
                                            ...prev,
                                            orderBy: 'createdAt',
                                            sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                        }))}>
                                            {searchParams.sort == null || searchParams.orderBy !== 'createdAt' ?
                                                <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                        </IconButton></TableCell>
                                }
                                {columnNames.includes('updatedAt') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Módosítva
                                        <IconButton onClick={() => setSearchParams(prev => ({
                                            ...prev,
                                            orderBy: 'updatedAt',
                                            sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                        }))}>
                                            {searchParams.sort == null || searchParams.orderBy !== 'updatedAt' ?
                                                <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                        </IconButton></TableCell>
                                }
                                {columnNames.includes('lastModifiedBy') &&
                                    <TableCell sx={{padding: "0px", width: "150px", textAlign: "center"}}>Módosította
                                        <IconButton onClick={() => setSearchParams(prev => ({
                                            ...prev,
                                            orderBy: 'lastModifiedBy',
                                            sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
                                        }))}>
                                            {searchParams.sort == null || searchParams.orderBy !== 'lastModifiedBy' ?
                                                <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                                                searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
                                        </IconButton></TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.rows == null ?
                                <TableRow sx={{textAlign: "center"}}>
                                    <TableCell colSpan={columnNames?.length || 8}
                                               sx={{padding: "200px !important", textAlign: "center"}}>
                                        <CircularProgress/>
                                    </TableCell>
                                </TableRow> :
                                <>
                                    {tableData.rows?.map((task, index) => (
                                        <TableRow key={index} hover
                                                  sx={{backgroundColor: task.archived ? "#eee" : !task.seen ? "#FFFAAA" : task.marked ? 'orange' : ''}}
                                                  onContextMenu={e => handleContextMenu(e, task)}>
                                            <TableCell padding='none' align='center' sx={{lineHeight: "0px"}}>
                                                <div style={{
                                                    display: "inline-flex",
                                                    padding: "2px",
                                                    width: "100%",
                                                    height: "30px !important",
                                                    justifyContent: "space-between"
                                                }}>
                                                    <Tooltip title={"Törlés"} placement="left">
                                                        <Delete onClick={() => handleDeletionClick(task)} sx={{
                                                            position: "relative",
                                                            top: "0px",
                                                            left: "0px",
                                                            width: "24px",
                                                            color: "#808080",
                                                            cursor: "pointer"
                                                        }}/>
                                                    </Tooltip>
                                                    <Tooltip title="Információ">
                                                        <Info sx={{
                                                            position: "relative",
                                                            top: "0px",
                                                            left: "0px",
                                                            color: "#808080",
                                                            cursor: "pointer",
                                                            width: "24px"
                                                        }} onClick={e => handleClickOpenTaskDetails(task)}/>
                                                    </Tooltip>
                                                    <Tooltip title={STATUSES[task.status]}>
                                                        {(() => {
                                                            switch (task.status) {
                                                                case 'NOT_STARTED':
                                                                    return <PlayArrowOutlined style={{
                                                                        position: "relative",
                                                                        top: "0px",
                                                                        color: "#808080",
                                                                        width: "24px"
                                                                    }}/>
                                                                case 'IN_PROGRESS':
                                                                    return <Autorenew style={{
                                                                        position: "relative",
                                                                        top: "0px",
                                                                        color: "#808080",
                                                                        width: "24px"
                                                                    }}/>
                                                                case 'DONE':
                                                                    return <Check style={{
                                                                        position: "relative",
                                                                        top: "0px",
                                                                        color: "#808080",
                                                                        width: "24px"
                                                                    }}/>
                                                                default:
                                                                    return <Icon sx={{width: "24px"}}/>;
                                                            }
                                                        })()}
                                                    </Tooltip>
                                                    <Tooltip title={PRIORITIES[task.priority]}>
                                                        {(() => {
                                                            switch (task.priority) {
                                                                case 'EXTRA_IMPORTANT':
                                                                    return <div style={{position: "relative", top: "3px", width: "24px"}}>
                                                                        <PriorityHigh sx={{
                                                                            color: "red",
                                                                            position: "absolute",
                                                                            left: "1px",
                                                                            fontSize: "1.2rem",
                                                                        }}/>
                                                                        <PriorityHigh sx={{
                                                                            color: "red",
                                                                            position: "absolute",
                                                                            left: "6px",
                                                                            fontSize: "1.2rem",
                                                                        }}/>
                                                                        <Icon/>
                                                                    </div>
                                                                case 'IMPORTANT':
                                                                    return <div style={{minWidth: "24px"}}><PriorityHigh sx={{
                                                                        color: "red",
                                                                        position: "relative",
                                                                        top: "3px",
                                                                        left: "2px",
                                                                        fontSize: "1.2rem",
                                                                    }}/></div>
                                                                case 'NORMAL':
                                                                    return <Icon sx={{width: "24px"}}/>;
                                                                case 'NOT_IMPORTANT':
                                                                    return <ReportOff style={{
                                                                        position: "relative",
                                                                        top: "0px",
                                                                        width: "24px",
                                                                        color: "#808080"
                                                                    }}/>
                                                                default:
                                                                    return <Icon sx={{width: "24px"}}/>;
                                                            }
                                                        })()}
                                                    </Tooltip>

                                                    {task.ownPriority ?
                                                        <Tooltip title="Saját Prioritás">
                                                            <Typography style={{width: "24px", minWidth: "24px", paddingTop: "0px"}}>{task.ownPriority}</Typography>
                                                        </Tooltip> : <Icon/>}

                                                    <Tooltip title={task?.marked ? "Megjelölve" : "Megjelölés"}>
                                                        {task?.marked ?
                                                            <Bookmark sx={{
                                                                position: "relative",
                                                                top: "0px",
                                                                left: "0px",
                                                                width: "24px",
                                                                color: "#808080",
                                                                cursor: "pointer"
                                                            }} onClick={(e) => setMarked(task.id, false, e)}/> :
                                                            <BookmarkBorder sx={{
                                                                position: "relative",
                                                                top: "0px",
                                                                left: "0px",
                                                                width: "24px",
                                                                color: "#808080",
                                                                cursor: "pointer"
                                                            }} onClick={(e) => setMarked(task.id, true, e)}/>}
                                                    </Tooltip>
                                                    <Tooltip title={task?.seen ? "Megtekintve" : "Olvasatlan"}>
                                                        {task?.seen ?
                                                            <MarkEmailRead sx={{
                                                                position: "relative",
                                                                top: "0px",
                                                                left: "0px",
                                                                width: "24px",
                                                                color: "#808080",
                                                                cursor: "pointer"
                                                            }} onClick={(e) => setSeen(task.id, false, e)}/> :
                                                            <Markunread sx={{
                                                                position: "relative",
                                                                top: "0px",
                                                                left: "0px",
                                                                width: "24px",
                                                                color: "#808080",
                                                                cursor: "pointer"
                                                            }} onClick={(e) => setSeen(task.id, true, e)}/>}
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                            {ALL_COLUMNS.filter(c => columnNames.includes(c.id)).map((column, index) => (
                                                <TableCell onClick={() => {
                                                    navigate(`/dashboard/tasks/${task.id}`)
                                                    if (task.seen === false) taskService.setSeen(task.id, true)
                                                }}
                                                           sx={{
                                                               cursor: "pointer",
                                                               color: task.archived ? "gray" : "",
                                                               padding: "0px 5px",
                                                               whiteSpace: "nowrap",
                                                               textOverflow: "ellipsis",
                                                               overflow: "hidden",
                                                               textAlign: column.align
                                                           }}
                                                           key={index}>{column.fun ? column.fun(task[column.id], task) : task[column.id]}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </>}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[3, 10, 25, 50]}
                    component="div"
                    count={tableData.totalCount}
                    rowsPerPage={parseInt(tableData.rowsPerPage)}
                    page={tableData.page}
                    onPageChange={(event, newPage) => setTableData((prev) => ({...prev, page: newPage}))}
                    onRowsPerPageChange={(event) => {
                        setTableData((prev) => ({...prev, rowsPerPage: event.target.value, page: 0}))
                        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, event.target.value)
                    }}
                    labelRowsPerPage="Elemek oldalanként:"
                />
            </Paper>

            <ConfirmationDialog
                title={"Biztosan törölni szeretnéd ezt a feladatot?"}
                content={
                    <>
                        {dialogState.object?.description} <br/>
                    </>
                }
                open={dialogState.open}
                onClose={handleClose}
                onConfirm={() => {
                    deleteTask(dialogState.object?.id)
                }}
            />

            <Menu
                open={contextMenu !== null}
                onClose={handleCloseContextMenu}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu !== null ? {top: contextMenu.mouseY, left: contextMenu.mouseX} : undefined}
            >
                <MenuItem onClick={() => {
                    handleCloseContextMenu()
                    setOpenSetPriorityDialog(true)
                }}><Edit sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Saját Prioritás</MenuItem>
            </Menu>

            <Dialog
                open={openSetPriorityDialog}
                onClose={handleOpenSetPriorityDialogClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        taskService.setOwnPriority(context.task.id, {
                            priority: formJson.priority,
                            noteText: formJson.noteText
                        })
                            .then(() => {
                                    sendAlertMessage("Prioritás sikeresen beállítva")
                                    retrieveTasks()
                                    handleOpenSetPriorityDialogClose()
                                }
                            )
                            .catch(error => sendAlertMessage(error?.message || "Prioritás beállítása sikertelen", 'error'))

                    },
                }}
            >
                <DialogTitle sx={{backgroundColor: "#1976d2", color: "white"}}>Saját Prioritás Hozzáadása</DialogTitle>
                <DialogContent sx={{maxWidth: "400px"}}>
                    <TextField
                        autoFocus
                        type="number"
                        margin="dense"
                        name="priority"
                        defaultValue={context?.task?.ownPriority}
                        label="Prioritás (1-10)"
                        fullWidth
                        slotProps={{
                            htmlInput: {
                                min: 1,
                                max: 10,
                                step: 1,
                                pattern: "[0-9]*",
                                onInput: (e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                },
                            }
                        }}
                    />

                    <TextField
                        margin="dense"
                        name="noteText"
                        defaultValue={context?.task?.noteText}
                        label="Jegyzet"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOpenSetPriorityDialogClose} color="error"
                            variant="outlined" sx={{marginRight: "auto"}}>Mégse</Button>
                    <Button type="submit" variant="contained">Mentés</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openTaskDetails}
                onClose={handleCloseTaskDetails}
                sx={{"& form": {borderRadius: "15px"}}}
            >
                <DialogTitle
                    sx={{backgroundColor: "#1976d2", color: "white", textAlign: "center"}}>Részletek</DialogTitle>
                <DialogContent>
                    <Table sx={tableStyle}>
                        <TableBody>
                            <TableRow>
                                <TableCell>Projekt</TableCell>
                                <TableCell>
                                    <Link sx={{cursor: "pointer"}}
                                          onClick={() => navigate(`/dashboard/project-tasks/projects/${taskDetailsContent?.projectId}`)}>{taskDetailsContent?.projectName}</Link>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Fejléc</TableCell>
                                <TableCell>
                                    <Link sx={{cursor: "pointer"}}
                                          onClick={() => navigate(`/dashboard/project-tasks/projects/${taskDetailsContent?.project?.id}/tasks/${taskDetailsContent?.projectTaskId}`)}>{taskDetailsContent?.projectTaskName}</Link>
                                </TableCell>
                            </TableRow>
                            <TableRow style={{borderBottom: "1px solid gray"}}>
                                <TableCell>Feladat</TableCell>
                                <TableCell>
                                    <Link sx={{cursor: "pointer"}}
                                          onClick={() => navigate(`/dashboard/tasks/${taskDetailsContent?.id}`)}>{limit(taskDetailsContent?.description, 30)}</Link>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Jelöltek</TableCell>
                                <TableCell>{taskDetailsContent?.candidates || '-'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Dolgozók</TableCell>
                                <TableCell>{taskDetailsContent?.users || '-'}</TableCell>
                            </TableRow>
                            {taskDetailsContent?.candidates?.includes(currentUser.username) &&
                                !taskDetailsContent?.users?.includes(currentUser.userId) &&
                                <TableRow>
                                    <TableCell sx={{textAlign: "right"}} colSpan={2}>
                                        <Button variant="contained" onClick={() => {
                                            taskService.take(taskDetailsContent?.id)
                                                .then(() => {
                                                    sendAlertMessage("Feladat felvétele sikeres")
                                                    retrieveTasks()
                                                })
                                                .catch(error => console.error(error))
                                        }}>Feladat Felvétele</Button>
                                    </TableCell>
                                </TableRow>}
                            <TableRow style={{borderTop: "1px solid gray"}}>
                                <TableCell>Státusz</TableCell>
                                <TableCell>{STATUSES[taskDetailsContent?.status]}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Prioritás</TableCell>
                                <TableCell>{PRIORITIES[taskDetailsContent?.priority]}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Előrehaladás</TableCell>
                                <TableCell>{taskDetailsContent?.progressLevel || 0} %</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        </>
    )
}